import { render, staticRenderFns } from "./StaffDocs.vue?vue&type=template&id=6fcb7b42&scoped=true&"
import script from "./StaffDocs.vue?vue&type=script&lang=js&"
export * from "./StaffDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb7b42",
  null
  
)

export default component.exports